export default __webpack_public_path__ + "cfda5aa74769040d41df61a7a0073bcf.svg";